import '../custom.css';
import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { EnvelopeFill, ChatDotsFill } from 'react-bootstrap-icons';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';

export default function ContactUs() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });
    const [status, setStatus] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setStatus(null);

        try {
            const response = await axios.post('/api/contact', {
                ...formData,
                recaptchaToken, 
            });

            setStatus({ type: 'success', message: response.data.message });
            setFormData({ name: '', email: '', subject: '', message: '' });
            
        } catch (error) {
            const errorMessage = error.response?.data?.error || 'An unexpected error occurred.';
            setStatus({ type: 'danger', message: errorMessage });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            {/* Hero */}
            <section className='full-bleed py-5 bg-primary-soft text-center'>
                <Container style={{ maxWidth: 960 }}>
                    <h1 className='display-5 fw-bold mb-3'>Contact&nbsp;Us</h1>
                    <p className='lead mb-4'>
                        Questions, feedback, or partnership ideas? We’d love to hear from you.
                    </p>
                </Container>
            </section>

            <section className='py-5'>
                <Container fluid='lg'>
                    {/* The "Email support" and "Live chat" boxes have been removed */}

                    {/* Contact form */}
                    <Row className='justify-content-center'>
                        <Col lg={8}>
                            <h2 className='fw-bold mb-4 text-center'>Send us a message</h2>
                            <Form onSubmit={handleSubmit}>
                                <Row className='g-3'>
                                    <Col md={6}>
                                        <Form.Control type='text' name='name' placeholder='Your name' value={formData.name} onChange={handleChange} required />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Control type='email' name='email' placeholder='Email address' value={formData.email} onChange={handleChange} required />
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Control type='text' name='subject' placeholder='Subject' value={formData.subject} onChange={handleChange} required />
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Control
                                            as='textarea'
                                            rows={5}
                                            name='message'
                                            placeholder='Your message'
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Col>
                                    
                                    <Col xs={12} className="d-flex justify-content-center my-3">
                                        <ReCAPTCHA
                                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                            onChange={(token) => setRecaptchaToken(token)}
                                        />
                                    </Col>

                                    <Col xs={12} className='text-center'>
                                        <Button type='submit' variant='primary' size='lg' disabled={submitting || !recaptchaToken}>
                                            {submitting ? 'Sending…' : 'Send Message'}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                            {status && (
                                <Alert variant={status.type} className='mt-4'>
                                    {status.message}
                                </Alert>
                            )}
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* CTA */}
            <section className='full-bleed py-5 text-center bg-primary text-white'>
                <div className='mx-auto' style={{ maxWidth: 720 }}>
                    <h3 className='fw-bold mb-3'>Prefer to dive right in?</h3>
                    <p className='lead mb-4'>Start your free trial and explore Greatly Social today.</p>
                    <Button href='/register' variant='light' size='lg'>Start Free Trial</Button>
                </div>
            </section>
        </>
    );
}

